import type {BoxProps} from '@tempo/core';

export const BODY_WIDTH = 834;

const ANDROID_PLAYER_HEIGH = 56; // 56dp (android unit);
const ANDROID_PLAYER_MARGIN_BOTTOM = 8; // 8dp (android unit)
const ANDROID_PLAYER_MARGIN_TOP_EXTRA = 16; // for extra space

export const ANDROID_PLAYER_TOTAL_HEIGHT =
	ANDROID_PLAYER_HEIGH +
	ANDROID_PLAYER_MARGIN_BOTTOM +
	ANDROID_PLAYER_MARGIN_TOP_EXTRA +
	'px';

export const TOUCHABLE_STYLE: BoxProps = {
	transform: 'scale(0.98)',
	opacity: 0.4,
};
export const TOUCHABLE_FEEDBACK: BoxProps = {
	transition: 'all ease 0.1s',
	cursor: 'pointer',
	sx: {
		WebkitTapHighlightColor: 'transparent',
		':not([data-disabled])': {
			_active: TOUCHABLE_STYLE,
		},
	},
};

export const DOT = ' ・ ';
